export default __webpack_public_path__ + "static/media/advance-right-image.a059eb7c.png";